import Button from '@/components/Button.jsx';

const PageInput = ({ label, value, disabled, onChange, onBlur, placeholder, rightButtonLabel, rightButtonOnClick, rightButtonDisabled }) => {
  return (
    <div className={'comp-page-input-row'}>
      <div className={'label'}>{label}</div>
      <div className={'input-wrapper'}>
        <input className={'input'} type={'text'} value={value || ''} disabled={disabled} onChange={onChange} onBlur={onBlur} placeholder={placeholder} />
        {rightButtonLabel && (
          <Button size={'lg'} onClick={rightButtonOnClick || (() => {})} disabled={rightButtonDisabled}>
            {rightButtonLabel}
          </Button>
        )}
      </div>
    </div>
  );
};

export default PageInput;
